export function getDashboardCards() {
  return [
    {
      id: 'evaluaciones',
      title: 'Evaluaciones\nTrianuales',
      backgroundClass: 'bg-[#08ad86]',
      to: '/evaluaciones-trianuales',
    },
    {
      id: 'toolbox',
      title: 'ToolBox',
      backgroundClass: 'bg-[#39b8b0]',
      to: '/toolbox',
    },
    {
      id: 'reportes',
      title: 'Reportes',
      backgroundClass: 'bg-[#77c291]',
      to: '/reportes',
    },
    {
      id: 'amarre',
      title: 'Amarre',
      backgroundClass: 'bg-[#0f6b9c]',
      to: '/amarre',
    },
  ];
}
